import { render, staticRenderFns } from "./OrderContent.vue?vue&type=template&id=65efc5d0&scoped=true"
import script from "./OrderContent.vue?vue&type=script&lang=js"
export * from "./OrderContent.vue?vue&type=script&lang=js"
import style0 from "./OrderContent.vue?vue&type=style&index=0&id=65efc5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efc5d0",
  null
  
)

export default component.exports